package org.tlsys.dto

import kotlinx.serialization.Serializable

@Serializable
class SecurityJournal(val records: List<JournalDto>)
